import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiFetch } from "../APIClient";
import {
  CancelReservationRequestBodyDto,
  CancelReservationResponseDto,
} from "../generated/generatedTypes";

const cancelReservation = async (
  reservationId: number,
  data: CancelReservationRequestBodyDto
): Promise<CancelReservationResponseDto> => {
  const response = await apiFetch(`api/reservation/${reservationId}/cancel`, {
    method: "POST",
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    throw new Error("예약을 취소하지 못했습니다. 잠시 후 다시 시도해주세요.");
  }

  return response.json();
};

export const useCancelReservation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      reservationId,
      cancellationReason,
    }: {
      reservationId: number;
      cancellationReason?: string;
    }) => cancelReservation(reservationId, { cancellationReason }),
    onSuccess: () => {
      // Invalidate relevant queries to refetch data
      queryClient.invalidateQueries({ queryKey: ["event"] });
      queryClient.invalidateQueries({ queryKey: ["events"] });
      queryClient.invalidateQueries({ queryKey: ["reservations"] });
      queryClient.invalidateQueries({ queryKey: ["reservationRequests"] });
      queryClient.invalidateQueries({ queryKey: ["myUpcomingReservations"] });
    },
  });
};
